// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"alert_imageContainer__g57dV","title":"alert_title__9545Q","description":"alert_description__qdCmM","container":"alert_container__UQ2DM"};